const transitionStreamName = {
  intro: 'intro',
  outro: 'outro',
};

export default transitionStreamName;
